import { render } from "./YedeklerView.vue?vue&type=template&id=78abf620"
import script from "./YedeklerView.vue?vue&type=script&lang=js"
export * from "./YedeklerView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__